
export const TXT_FILTER_SEQUENCE_ID = 'txt-filter-sequenceId';
export const TXT_FILTER_SEQUENCE_NAME = 'txt-filter-sequenceName';
export const TXT_FILTER_SEQUENCE_TYPE = 'txt-filter-sequenceType';
export const TXT_FILTER_SEQUENCE = 'txt-filter-sequence';
export const TXT_FILTER_SEQUENCE_FORMULA = 'txt-filter-sequenceFormula';
export const TXT_FILTER_SEQUENCE_MASS_FROM = 'txt-filter-sequenceMassFrom';
export const TXT_FILTER_SEQUENCE_MASS_TO = 'txt-filter-sequenceMassTo';
export const TXT_FILTER_SEQUENCE_FAMILY = 'txt-filter-sequenceFamily';
export const TXT_FILTER_ORGANISM = 'txt-filter-organism';
export const TXT_FILTER_SEQUENCE_N_MODIFICATION = 'txt-filter-sequenceNModification';
export const TXT_FILTER_SEQUENCE_C_MODIFICATION = 'txt-filter-sequenceCModification';
export const TXT_FILTER_SEQUENCE_B_MODIFICATION = 'txt-filter-sequenceBModification';
export const TXT_FILTER_SEQUENCE_IDENTIFIER = 'txt-filter-sequenceIdentifier';
export const TXT_FILTER_SEQUENCE_USAGES_FROM = 'txt-filter-usages-from';
export const TXT_FILTER_SEQUENCE_USAGES_TO = 'txt-filter-usages-to';

export const SORT_ID = 'id';
export const SORT_SEQUENCE_NAME = 'sequenceName';
export const SORT_SEQUENCE_TYPE = 'sequenceType';
export const SORT_SEQUENCE = 'sequence';
export const SORT_SEQUENCE_FORMULA = 'sequenceFormula';
export const SORT_SEQUENCE_MASS_FROM = 'sequenceMassFrom';
export const SORT_SEQUNECE_MASS_TO = 'sequenceMassTo';
export const SORT_FAMILY = 'family';
export const SORT_ORGANISM = 'organism';
export const SORT_N_MODIFICATION = 'nModification';
export const SORT_C_MODIFICATION = 'cModification';
export const SORT_B_MODIFICATION = 'bModification';
export const SORT_IDENTIFIER = 'identifier';
export const SORT_SEQUENCE_MASS = 'sequenceMass';
export const SORT_USAGES = 'usages';
export const SORT_USAGES_FROM = 'usagesFrom';
export const SORT_USAGES_TO = 'usagesTo';
